export default __webpack_public_path__ + "static/media/products.280fb9ff.png";